module.exports = __webpack_public_path__ + "static/media/image-ibel.3d180741.png";